/* */
'use strict';

// var _ = = require('lodash');

function PopupDirective ($timeout) {

  var link = function ($scope, $el, attrs, ctrls, transclude) {
    var mapCtrl = ctrls[0];
    var Actions = mapCtrl.Actions;
    var Store = mapCtrl.Store;
    var tScope, tClone;

    ////////////////////////////////////////////////////////////////////////////
    // Attribute Listeners
    ////////////////////////////////////////////////////////////////////////////

    function onShowChanged (show, prev) {
      if (show !== prev) {
        var activeLayer = Store.get('activeLayer');
        if (activeLayer) {
          if (show !== undefined && !show) {
            Actions.CloseActiveLayerPopup.dispatch(activeLayer);
            destroyPopupContent();
          } else if (show) {
            // NOTE: we recreate the popup content everytime to ensure we do not
            // lose any bindings when leaflet removes the popup from the DOM.
            createPopupContent();
          }
        }
      }
    }

    $scope.$watch('show', onShowChanged);

    ////////////////////////////////////////////////////////////////////////////
    // Store Listeners
    ////////////////////////////////////////////////////////////////////////////


    function onChangedActiveLayer () {
      var activeLayer = Store.get('activeLayer');

      // HACK
      // The $timeout is used to make sure that the map directive `activeLayer`
      // and other bindings are updated before the controllers for the popup
      // content are initialized
      $timeout(function () {
        if (activeLayer) {
          if ($scope.show === true) {
            createPopupContent(); // re-initialize the content
          } else {
            // change visibility and let onShowChanged re-initialize the content
            $scope.show = true;
          }
        } else {
          if ($scope.show === false) {
            destroyPopupContent();
          } else {
            // change visibility and let onShowChanged destroy the content
            $scope.show = false;
          }
        }
      }, 10);
    }

    function onChangedPopupState () {
      // HACK...
      // Same as above to put them in the same digest.
      $timeout(function () {
        var open = Store.get('activeLayerPopupOpen');
        $scope.show = open;
      }, 10);
    }

    Store.on(Store.Events.ChangedActiveLayer, onChangedActiveLayer);
    Store.on(Store.Events.ChangedPopupState, onChangedPopupState);

    ////////////////////////////////////////////////////////////////////////////
    // Helpers
    ////////////////////////////////////////////////////////////////////////////

    // var createPopupContent = _.debounce(function _createPopupContent () {
    //   destroyPopupContent();

    //   transclude(function (clone, scope) {
    //     $el.append(clone);
    //     tClone = clone;
    //     tScope = scope;
    //   });

    //   Actions.SetActiveLayerPopupContent.dispatch(tClone);
    // }, 10);

    function createPopupContent () {
      destroyPopupContent();

      transclude(function (clone, scope) {
        $el.append(clone);
        tClone = clone;
        tScope = scope;
      });

      Actions.SetActiveLayerPopupContent.dispatch(tClone);
    }

    function destroyPopupContent () {
      if (tScope) {
        tScope.$destroy();
        tClone = null;
        tScope = null;
        $el.empty();
      }
    }
  };

  return  {
    link: link,
    require: ['^sbMap'],
    scope: {
      show: '='
    },
    transclude: true
  };
}

PopupDirective.$inject = ['$timeout'];
module.exports = PopupDirective;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/popup/PopupDirective.js